<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.has-text-centered
            h1.title Dispositivo {{ $route.params.id }}
              |
              a.button.is-black.is-rounded.is-small(@click="backToPage")
                i.fas.fa-times
        .columns
          .column
            Formulario
</template>

<script>
  import NavBar from './layout/NavBar.vue'
  import Loader from '@/components/shared/Loader.vue'
  import Formulario from './components/Formulario'
  export default {
    name: 'Registro',
    name: 'CodigosQRComponentes',
    components: { NavBar, Loader, Formulario },
    data() {
      return {
        isLoading: true
      }
    },
    methods: {
      iniciarComponente() {
        setTimeout(() => {
          this.isLoading = false
        }, 300)
      },
      backToPage () {
        this.$router.back()
      },
      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : null,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      }
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/codigosQR_Componentes/Registro.vue